export const hoaLessons = [
  {
    id: 'hoa-1',
    title: 'Bảng tuần hoàn các nguyên tố hóa học',
    slug: 'bang-tuan-hoan',
    grade: 10,
    subject: 'Hóa học',
    views: 34200,
    readTime: 25,
    excerpt: 'Cấu trúc bảng tuần hoàn, chu kỳ, nhóm và quy luật biến đổi tính chất các nguyên tố.',
    category: 'Hóa đại cương'
  },
  {
    id: 'hoa-2',
    title: 'Phương trình hóa học và cân bằng',
    slug: 'phuong-trinh-hoa-hoc',
    grade: 8,
    subject: 'Hóa học',
    views: 29800,
    readTime: 20,
    excerpt: 'Cách viết và cân bằng phương trình hóa học, định luật bảo toàn khối lượng.',
    category: 'Hóa đại cương'
  },
  {
    id: 'hoa-3',
    title: 'Axit - Bazơ - Muối',
    slug: 'axit-bazo-muoi',
    grade: 9,
    subject: 'Hóa học',
    views: 31500,
    readTime: 22,
    excerpt: 'Tính chất hóa học của axit, bazơ, muối và phản ứng trao đổi ion.',
    category: 'Hóa vô cơ'
  },
  {
    id: 'hoa-4',
    title: 'Hidrocacbon no - Ankan',
    slug: 'hidrocacbon-no-ankan',
    grade: 11,
    subject: 'Hóa học',
    views: 22600,
    readTime: 24,
    excerpt: 'Cấu tạo, tính chất và danh pháp của Ankan - hidrocacbon no mạch hở.',
    category: 'Hóa hữu cơ'
  },
  {
    id: 'hoa-5',
    title: 'Liên kết hóa học',
    slug: 'lien-ket-hoa-hoc',
    grade: 10,
    subject: 'Hóa học',
    views: 26900,
    readTime: 18,
    excerpt: 'Liên kết ion, liên kết cộng hóa trị và liên kết kim loại - đặc điểm và ví dụ.',
    category: 'Hóa đại cương'
  },
  {
    id: 'hoa-6',
    title: 'Tốc độ phản ứng hóa học',
    slug: 'toc-do-phan-ung',
    grade: 11,
    subject: 'Hóa học',
    views: 19200,
    readTime: 16,
    excerpt: 'Các yếu tố ảnh hưởng đến tốc độ phản ứng: nhiệt độ, nồng độ, áp suất, xúc tác.',
    category: 'Hóa đại cương'
  }
];
